import { render, staticRenderFns } from "./AddOrganizationCard.vue?vue&type=template&id=6efa3888&"
import script from "./AddOrganizationCard.vue?vue&type=script&lang=js&"
export * from "./AddOrganizationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports